import React from 'react';
import icons from './icons';

type Props = {
  name: keyof typeof icons;
  classes?: string;
  styles?: React.CSSProperties;
};

const Icon: React.FC<Props> = ({ name, classes, styles }) => {
  const icon = icons[name];
  return (
    <div className={classes} style={styles}>
      {icon}
    </div>
  );
};

export default Icon;
